<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CommonContinueRegistration',
  props: {
    btnClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('local', ['getRouteNameSteps', 'getStepStatus']),
    toNext () {
      return this.localePath(this.getRouteNameSteps[this.getStepStatus])
      // return '/'
    }
  }
}
</script>

<template>
  <div>
    <BaseButton
      v-if="$auth.loggedIn && getStepStatus"
      tag="nuxt-link"
      size="sm-md"
      :to="toNext"
      :class="btnClass"
      class="w-auto lg:w-[250px]"
      :label="$t('actions.continue_registration')"
    />
    <slot v-else name="else" />
  </div>
</template>

<style scoped lang="scss">

</style>
